import { useHistory } from 'react-router-dom';
import { LocationType } from 'flow/types/Location';

/**
 * A back handler for a page that a link can open with `{ from }` state, such
 * as a calendar opened from the contact card. With `from` set, the page the
 * link was on is the previous history entry (a deep link cannot carry
 * state), so going back to it keeps that page's own state. Without it, for
 * example after the page's own sub-pages, which navigate without state,
 * back goes to the path `getFallbackPath` returns.
 */
const useBackToOrigin = (getFallbackPath: () => string) => {
    const history = useHistory<LocationType>();

    return history.location.state?.from
        ? () => history.goBack()
        : () => history.push(getFallbackPath());
};

export default useBackToOrigin;
